import { render, staticRenderFns } from "./ResultCourseFilter.vue?vue&type=template&id=0c5b5ff4&scoped=true&"
import script from "./ResultCourseFilter.vue?vue&type=script&lang=js&"
export * from "./ResultCourseFilter.vue?vue&type=script&lang=js&"
import style0 from "./ResultCourseFilter.vue?vue&type=style&index=0&id=0c5b5ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b5ff4",
  null
  
)

export default component.exports